<!-- conditionally render based on whether it is ECF / PSTX -->
<ng-container>
  <div class="row justify-content-center mb-5">
    <div class="col-md-10 col-lg-8">
      <form [formGroup]="form" [class.show-form-error]="showFormError" (ngSubmit)="submit()">
        <div class="row">
          <div class="col-md-12">
            <mat-radio-group name="paymentType" formControlName="paymentType">
              @for (type of paymentOptions; track type) {
                @if (!type.show || type.show()) {
                  <div
                    class="custom-control custom-radio tw-relative tw-items-center"
                    [class.active]="form.controls.paymentType?.value === type.key"
                    [class.disabled]="disablePaymentType(type.key)"
                    (click)="
                      !isPSTX || type.key !== PaymentType.MaybankFPX
                        ? selectPaymentType(type.key)
                        : null
                    "
                  >
                  @if ((!isPSTX && type.key === PaymentType.Wallet)
                  || (isPSTX && type.key === PaymentType.DuitNow)) {
                    <span class="tw-absolute -tw-top-4 tw-font-bold tw-text-white tw-bg-secondary-light tw-p-1 tw-rounded-md">
                      {{ ('investment.recommended' | translate).toLocaleUpperCase() }}
                    </span> }
                    <mat-radio-button
                      class="type-radio"
                      [value]="type.key"
                      [disabled]="isPSTX && type.key === PaymentType.MaybankFPX"
                    >
                    </mat-radio-button>
                    <div
                      class="d-flex tw-items-center w-100 option-panel"
                      [class.grayscale]="isPSTX && type.key === PaymentType.MaybankFPX"
                    >
                      <div class="text-panel w-100">
                        <div class="type-label font-weight-extrabold text-black">
                          {{ 'investment.' + type.value | translate }}
                          @if (type.key === PaymentType.Wallet) {
                            <span class="tw-text-base">{{ 'investment.walletAvailableBalance' | translate: { amount: (wallet?.withdrawableBalance ?? 0) | numberSuffix: { numberFormat: '1.2-2' } } }}</span>
                          }
                          @if (type.key === PaymentType.Wallet || type.key === PaymentType.DuitNow) {
                            <span class="tw-ml-2 tw-text-xs tw-font-bold tw-text-white tw-bg-secondary-light tw-align-middle tw-p-1 tw-rounded-md">
{{ 'checkoutTags.instant' | translate }}
                            </span>
                          } @else {
                            <span class="tw-ml-2 tw-text-xs tw-font-bold tw-text-warning-dark tw-bg-warning-light tw-align-middle tw-p-1 tw-rounded-md">
                              {{ 'checkoutTags.verify' | translate }}
                            </span>
                          }
                          @if (type.key === PaymentType.Wallet && type.key === getActivePaymentType() && (difference??0) > 0) {
                            <span class="tw-text-sm tw-ml-2">{{ 'investment.walletInsufficientBalance' | translate: { 
                              target: (investment.pledgedAmount | numberSuffix: { numberFormat: '1.2-2' })
                              , need: (difference | numberSuffix: { numberFormat: '1.2-2' }) } }}</span>
                          }
                        </div>
                        @if (isPSTX && type.key === PaymentType.MaybankFPX) {
                          <div class="font-size-larger mt-3">
                            {{ 'investment.comingSoon' | translate }}
                          </div>
                        }
                      </div>
                      @if (type.key === PaymentType.MaybankFPX) {
                        <div class="fpx-img pitchin-icon-fpx tw-cursor-default"></div>
                      }
                      @if (type.key === PaymentType.DuitNow) {
                        <div class="fpx-img pitchin-icon-duitnow tw-cursor-default"></div>
                      }
                      @if (type.key === PaymentType.Wallet && difference > 0) {
<button class="btn btn-primary-border view-btn tw-w-fit tw-p-2" type="button" (click)="$event.stopPropagation(); deposit()">{{ ' + ' + ('mysec.TopUp' | translate) }}</button>
                      }
                    </div>
                  </div>
                }
                @if (
                  form.value.paymentType === type.key &&
                  (type.key === PaymentType.Cheque ||
                    type.key === PaymentType.Swift ||
                    type.key === PaymentType.BankIn)
                ) {
                  <ng-template *ngTemplateOutlet="trustAccount; context: { type: type }">
                  </ng-template>
                }
              }
            </mat-radio-group>
          </div>
        </div>
        <div class="row justify-content-center mt-5">
          <div class="col-sm-7">
            <button [disabled]="form.value.paymentType === PaymentType.Wallet && paymentAmount > (wallet?.withdrawableBalance??0)" class="btn btn-primary btn-continue" type="submit">
              {{ 'investment.continue' | translate }}
            </button>
            @if (
              receiptType === ReceiptType.Investment || receiptType === ReceiptType.OnboardingFee
            ) {
              <div class="pay-later">
                <span
                  class="cursor-pointer"
                  [routerLink]="continueLink"
                  [queryParams]="{
                    campaignSlug: campaign.slug,
                    investmentId: investment.id,
                    investmentStatus: investment.investmentStatus,
                    campaignStatus: campaign.campaignStatus,
                  }"
                  (click)="logPaylater()"
                >
                  {{ 'investment.continuePayLater' | translate }}
                </span>
              </div>
            }
            @if (receiptType === ReceiptType.Wallet) {
              <div class="pay-later">
                <span class="cursor-pointer" (click)="cancelPayment()">
                  {{ 'mysec.cancelTopUp' | translate }}
                </span>
              </div>
            }
          </div>
        </div>
        <div class="tw-mt-5 tw-text-center">
          <button
            type="button"
            (click)="isHelpCollapsed = false"
            [attr.aria-expanded]="!isHelpCollapsed"
            aria-controls="helpCollapse"
            class="p-link-secondary p-link-underline tw-mb-2.5 tw-bg-transparent tw-p-0"
          >
            Need help?
          </button>

          <div
            #collapse="ngbCollapse"
            [(ngbCollapse)]="isHelpCollapsed"
            aria-controls="helpCollapse"
          >
            <app-alert-bar
              [title]="'investment.contactUsForHelpTitle' | translate"
              [type]="'warning'"
            >
              @if (!referenceNo) {
                <p [innerHTML]="'investment.contactUsForHelpDescription' | translate"></p>
              } @else {
                <p
                  [innerHTML]="
                    'investment.contactUsForHelpDescriptionWithRef'
                      | translate: { ref: referenceNo }
                  "
                ></p>
              }
            </app-alert-bar>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>
<ng-template #trustAccount let-type="type">
  @if (!isPSTX && (type.key == PaymentType.Cheque || type.key == PaymentType.BankIn)) {
    <div class="row account-row">
      <div class="col-md-6 col-sm-6">
        {{
          (role == Role.IssuerRep ? 'pitchIN Account Details' : 'investment.pitchINEcfTrustAccount')
            | translate
        }}
      </div>
      <div class="col-md 6 col-sm-6 description-panel">
        @if (role != Role.IssuerRep) {
          <div>{{ 'investment.ecfTrustAccount' | translate }}</div>
        }
        <div class="bank-account-no font-weight-bold">{{ paymentMethodInfo?.accountName }}</div>
        <div class="font-size-large font-weight-extrabold">{{ paymentMethodInfo?.bankName }}</div>
        <div class="bank-account-no">{{ paymentMethodInfo?.accountNumber }}</div>
      </div>
    </div>
  }
  @if (isPSTX && (type.key == PaymentType.Cheque || type.key == PaymentType.BankIn)) {
    <div class="row account-row">
      <div class="col-md-6 col-sm-6">
        {{
          (role == Role.IssuerRep
            ? 'pitchIN Account Details'
            : 'investment.pitchINPstxTrustAccount'
          ) | translate
        }}
      </div>
      <div class="col-md-6 col-sm-6 description-panel">
        <div class="bank-account-no font-weight-bold">{{ paymentMethodInfo?.accountName }}</div>
        <div class="font-size-large font-weight-extrabold">{{ paymentMethodInfo?.bankName }}</div>
        <div class="bank-account-no">{{ paymentMethodInfo?.accountNumber }}</div>
      </div>
    </div>
  }
  @if (type.key == PaymentType.Swift) {
    <div class="row account-row">
      <div class="col-md-6">
        <div class="tw-font-bold">{{ 'common.pitchPlatformsSdnBhd' | translate }}</div>
        <div
          [innerHTML]="'E-12-08, Menara Suezcap 2, <br/> KL Gateway, 2, Jalan Kerinchi, <br/> 59200 Kuala Lumpur, <br/> Malaysia'"
        ></div>
      </div>
      <div class="col-md-6 description-panel">
        <div class="tw-font-bold">{{ paymentMethodInfo?.accountName }}</div>
        <div class="tw-mb-1.5">{{ paymentMethodInfo?.accountNumber }}</div>
        <div class="tw-font-bold">{{ paymentMethodInfo?.bankName }}</div>
        <div [innerHTML]="paymentMethodInfo?.address"></div>
      </div>
    </div>
  }
  @if (type.key == PaymentType.Swift) {
    <div class="row account-row">
      <div class="col-md-8 col-sm-7">{{ 'investment.swiftCode' | translate }}</div>
      <div class="col-md 4 col-sm-5 description-panel">
        <div class="font-size-large font-weight-bold">{{ paymentMethodInfo?.swiftCode }}</div>
      </div>
    </div>
  }
  <div class="row account-row">
    <div class="col-md-8 col-sm-7">
      {{
        (receiptType == ReceiptType.Wallet ? 'mysec.topUpAmount' : 'investment.paymentAmount')
          | translate
      }}

      @if (type.key === PaymentType.Swift && role !== Role.IssuerRep) {
        <span class="tw-block tw-text-sm tw-italic tw-text-black tw-text-opacity-70">
          {{ 'mysec.topUpDescription' | translate }}
        </span>
      }
    </div>
    <div class="col-md 4 col-sm-5 description-panel">
      <div class="account font-size-large">
        <span class="text-primary font-weight-extrabold">{{ paymentAmount | numberSuffix }}</span>
        @if (receiptType == ReceiptType.Investment) {
          <span>({{ lotAmount }} {{ 'investment.lots_plural' | translate }})</span>
        }
      </div>
    </div>
    @if (receiptType !== ReceiptType.Wallet) {
      <div class="col-md-12 pt-3">
        <div class="row note-row">
          <div class="col-md-9 col-sm-7 note">
            {{ 'investment.noteForReferenceNo' | translate }}
          </div>
          <div class="col-md 3 col-sm-5 description-panel">
            <div class="ref-no">{{ 'investment.refNo' | translate }}</div>
            <div class="font-size-large font-weight-bold">{{ referenceNo }}</div>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="row account-row border-bottom-none">
    <div class="col-md-8 col-sm-7 font-italic">
      {{
        (type.key == PaymentType.Cheque
          ? 'investment.uploadChequeReceiptOrEmail'
          : 'investment.uploadReceiptOrEmail'
        ) | translate
      }}
    </div>
    <div class="col-md-4 col-sm-5 description-panel">
      <div class="input-field" [class.disabled]="isLoading">
        @for (doc of documents; track doc; let i = $index) {
          @if (!doc) {
            <div
              class="document-upload cursor-pointer"
              agmoUploader
              [accept]="accept"
              [multiple]="true"
              (selectFiles)="selectFile($event, i)"
            >
              <div class="document-text text-left">
                {{ 'investment.uploadReceipt' | translate }}
              </div>
              <div class="pitchin-icon pitchin-icon-upload"></div>
            </div>
          }
          @if (doc) {
            <div class="document-upload uploaded">
              <div class="document-text text-left">{{ doc.name }}</div>
              <div class="pitchin-icon pitchin-icon-delete" (click)="removeDocument(i)"></div>
            </div>
          }
        }
      </div>

      @if (isLoading) {
        <agmo-loading></agmo-loading>
      }
    </div>
  </div>
</ng-template>
